<template>
    <div>
        <AddTracker></AddTracker>
        <div class="container-fluid px-0">
            <div class="row no-gutters">
                <div class="col-lg-4 col-md-5 col-sm-5 col-xl-3 sidebar bg-dark">
                    <div class="sidebar-sticky accordion">

                        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center p-2">
                            <p class="mx-4 text-white" v-if="users.length == 1">{{users.length}} {{$t('user')}}</p>
                            <p class="mx-4 text-white" v-else>{{users.length}} {{$t('users')}}</p>
                            <a class="btn btn-success btn-sm" v-on:click="on_add_user()">{{$t('add_user')}}</a>
                        </div> <li v-for="user in users" class="nav-item" :key="user.id">
                            <div class="nav-link" v-on:click="on_select(user)"
                                v-bind:class="{'active': (selected&&selected.id==user.id) }">
                                {{user.email}}({{user.visible_devices.length}})
                            </div>
                        </li>

                    </div>
                </div>
                <div role="main" class="col-sm-7 col-md-7 ml-sm-auto col-lg-8  col-xl-9 mx-0 mt-4">
                    <h5 class="mx-2">{{$t('public_desc')}}</h5>
                    <br>
                    <div class="mx-2" v-if='selected'>
                        <div class="m-2">
                            <label class="font-weight-bold" for="email_admin">Email</label>
                            <input id="email_admin" type="text" class="form-control col-lg-8" v-model="selected.email" autofocus
                                    v-if="!selected.id">
                            <div class="text" v-if="selected.id">{{selected.email}}</div>
                        </div>
                        <div class="m-2" v-if="selected.id">
                            <button class="btn btn-primary" v-on:click="send_password_reset(selected)">{{$t('send_reset_pwd')}}
                            </button>
                        </div>
                         <div class="mx-2 my-4">
                              <p class="font-weight-bold">{{$t('user_role')}}</p>
                              <select class="form-control col-lg-8" v-model="selected.role">
                                  <option value="sub_user">{{$t('sub_user')}}</option>
                                  <option value="sub_admin">{{$t('sub_admin')}}</option>
                              </select>
                            </div>
                        <div class="mx-2 " v-if="selected.id">
                            <p class="font-weight-bold">{{$t('visible_devices')}}</p>
                            <div v-if="devices_ids">
                                <multiselect
                                        :value="selected.visible_devices"
                                        :options="devices_options"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        :placeholder="$t('select_visibles_devices')"
                                        :select-label="$t('select')"
                                        :selected-label="$t('selected')"
                                        :deselect-label="$t('deselect_label')"
                                        :custom-label="device_label"
                                        @select="deviceSelect"
                                        @remove="deviceRemove"
                                >
                                </multiselect>

                            </div>
                        </div>
                        <div v-if="error_msg" class="m-2">
                            <h4 class="text-danger font-italic">{{error_msg}}</h4>
                        </div>
                        <div v-if="success_msg" class="m-2">
                            <h5 class="text-primary">{{success_msg}}</h5>
                        </div>
                        <div class="row mx-2 mt-4">
                            <button v-if="selected.id" class="btn btn-success" v-on:click="save(selected)">
                                {{$t('Save')}}
                            </button>
                            <button v-if="!selected.id" class="btn btn-success" v-on:click="save(selected)">
                                {{$t('create_user')}}
                            </button>
                            <button v-if="selected.id" class="btn btn-danger" v-on:click="will_delete(selected)">
                                {{$t('delete')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="delete_modal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">{{$t('delete_user')}}
                                        <span v-if="selected" v-text="selected.name"></span>
                                    </h4>
                                </div>
                                <div class="modal-body">
                                    <h5>{{$t('delete_user_definitive')}}</h5>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" @click="cancel_delete">
                                        {{$t('cancel')}}
                                    </button>
                                    <button id='delete-btn' class="btn btn-danger" v-on:click="on_delete(selected)">
                                        {{$t('delete')}}
                                    </button>
                                </div>
                            </div><!-- /.modal-content -->
                        </div><!-- /.modal-dialog -->
                    </div><!-- /.modal -->
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {HTTP} from '../http-constants'
    import Multiselect from 'vue-multiselect'


    export default {
        components: {
            multiselect: Multiselect,
        },
        data() {
            return {
                selected: null,
                users: [],
                devices: [],
                devices_ids: [],
                devices_options: [],
                role: 'sub_user',
                error_msg: null,
                success_msg: null,
                delete_modal: false,
            }
        },
        methods: {
            'load_users': function () {
                var self = this;
                HTTP.get('/users/subusers/',)
                    .then(function (re) {
                        self.users = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'device_label': function (option) {
                if (option < 0) {
                    return app.$t('select_all');
                }
                var devices = this.devices.filter(a => a.id == option);
                if (devices.length) {
                    return devices[0].name;
                }
                return `${option}`
            },
            'deviceSelect': function (option) {
                if (option === -1) {
                    this.selected.visible_devices = this.devices_ids;
                } else {
                    this.selected.visible_devices.push(option);
                }
            },
            'deviceRemove': function (option) {
                var idx = this.selected.visible_devices.indexOf(option);
                if (idx >= 0) {
                    this.selected.visible_devices.splice(idx, 1);
                }
            },
            'load_devices': function () {
                var self = this;
                HTTP.get('/devices/?type=tracker&sort=name',)
                    .then(function (re) {
                        self.devices = re.data;
                        self.devices_ids = self.devices.map(a => a.id);

                        self.devices_options = self.devices_ids.slice();
                        self.devices_options.unshift(-1);
                        console.log('Options: ' + self.devices_options.length);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'on_add_user': function () {
                this.selected = {'email': "", 'role': 'sub_user'};
            },
            'on_select': function (user) {
                this.error_msg = null;
                this.selected = user;
            },
            'will_delete': function (user) {
                this.delete_modal = true
            },
            'cancel_delete': function(){
                this.delete_modal = false
            },
            'on_delete': function (user) {
                var self = this;
                this.delete_modal = false
                HTTP.delete("/users/subusers/" + user.id + "/")
                    .then(function (re) {
                        var idx = self.users.indexOf(user);
                        if (idx >= 0) {
                            if (user == self.selected) {
                                self.selected = null;
                            }
                            self.users.splice(idx, 1);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            'save': function (user) {
                var self = this;
                if (!user.id) {
                    HTTP.post('/users/subusers/', user)
                        .then(function (re) {
                            user = re.data
                            var idx = self.users.indexOf(user);
                            if (idx >= 0) {
                                self.users[idx] = user;
                                self.selected = self.users[idx];
                            } else {
                                self.users.push(user)
                                self.selected = user
                            }
                            self.error_msg = null;
                        })
                        .catch(function (error) {
                            self.error_msg = app.$t('email_already_exist_account');
                            console.log(error);
                        });
                } else {
                    HTTP.patch('/users/subusers/' + user.id + '/', user)
                        .then(function (re) {
                            var idx = self.users.indexOf(user);
                            if (idx >= 0) {
                                self.users[idx] = re.data;
                                self.selected = self.users[idx];
                            }
                            self.success_msg = app.$t('user_updated');
                            self.error_msg = null;
                        })
                        .catch(function (error) {
                            console.log(error)
                            self.error_msg = app.$t('error');
                        });
                }
            },
            'send_password_reset': function (user) {
                let self = this;
                let bodyData = {'email': user.email};

                HTTP.post('api/v1/auth/password_reset/', bodyData)
                    .then(function (re) {
                        self.error_msg = app.$t('email_sent');
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.error_msg = app.$t('error');
                    });
            }
        },
        created: function () {
        },
        mounted: function () {
            this.load_devices();
            this.load_users();
        }
    }
</script>